<template>
  <div>
    <v-textarea
      v-model="localValue"
      rows="20"
      @keydown.tab.prevent="onPressTab($event)"
      @keydown.enter.prevent="onPressEnter($event)"
      :label="label"
      solo flat
      :hide-details="hideDetails"
      :readonly="readonly"/>
    <div>
      <strong class="red--text" v-if="!isSchemaValid">Invalid JSON</strong>
      <strong class="green--text" v-else>Valid JSON</strong>
    </div>
  </div>
</template>

<script>
import Field from '@/mixins/Field'

export default {
  props: {
    label: String,
    readonly: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [Field],
  name: 'JsonTextarea',
  computed: {
    isSchemaValid () {
      try {
        return JSON.parse(this.value) instanceof Object
      } catch (e) {
        return false
      }
    }
  },
  methods: {
    /**
     * Method called when pressing tab within the editor textarea
     *
     * @param evt
     */
    onPressTab (evt) {
      if (!evt) {
        return
      }
      evt.preventDefault()

      let val = evt.target.value
      let selectionStart = evt.target.selectionStart
      let selectionEnd = evt.target.selectionEnd

      evt.target.value = val.substring(0, selectionStart) + '\t' + val.substring(selectionEnd)
      evt.target.selectionStart = evt.target.selectionEnd = selectionStart + 1

      return false
    },
    /**
     * Method called when pressing enter inside the editor textarea (preserves tabs alignment)
     *
     * @param evt
     */
    onPressEnter (evt) {
      if (!evt) {
        return
      }
      evt.preventDefault()

      let val = evt.target.value
      let selectionStart = evt.target.selectionStart
      let selectionEnd = evt.target.selectionEnd

      let before = val.substring(0, selectionStart)
      let after = val.substring(selectionEnd)
      let currentLine = before.split('\n').pop()
      let currentIndent = currentLine.match(/^\s*/)[0]
      let selectionOffset = 0

      evt.target.value = before + '\n' + currentIndent + after
      evt.target.selectionStart = evt.target.selectionEnd = selectionStart + 1 + currentIndent.length + selectionOffset

      return false
    }
  }
}
</script>
